import { createPortal } from 'react-dom'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import type { ReactNode } from 'react'
import { usePushBackHandler } from '../../../context/BackStackContext'
import { IconButton } from '../../Common/IconButton'
import { ScreenGuideHost } from '../../ScreenGuide'
import './SideNavPageShell.css'

type SideNavPageShellProps = {
  title: string
  eyebrow?: string
  screenGuideId?: string
  onClose: () => void
  children: ReactNode
  footer?: ReactNode
  uiName?: string
}

/** Member-only full-viewport portal for pages launched from the menu drawer. */
export const SideNavPageShell = ({ title, eyebrow, screenGuideId, onClose, children, footer, uiName }: SideNavPageShellProps) => {
  usePushBackHandler(onClose)
  const shell = <section className="sideNavPageShell" role="region" aria-label={title} data-ui-name={uiName}>
    <header className="sideNavPageShell__header">
      <div>{eyebrow ? <span>{eyebrow}</span> : null}<h2>{title}</h2></div>
      <div className="flex items-center gap-2">
        {screenGuideId ? (
          <ScreenGuideHost screenId={screenGuideId} className="screenGuideLauncher--topbar" />
        ) : null}
        <IconButton variant="tertiary" size="md" label={`Close ${title}`} icon={<CloseRoundedIcon fontSize="small" />} onClick={onClose} />
      </div>
    </header>
    <main className="sideNavPageShell__body">{children}</main>
    {footer ? <footer className="sideNavPageShell__footer">{footer}</footer> : null}
  </section>
  return typeof document === 'undefined' ? shell : createPortal(shell, document.body)
}
